import React, { useState, useEffect, useRef } from 'react';
import { ArrowDownIcon, GlobalFlagIcon, USFlagIcon } from '../../../assets/svg/login-icons';
import { changeRegion } from '../../../assets/appConstants';
import '../../../assets/stylesheets/env-selector.css';
import { postMessage } from '../../../services/utils';
import { MESSAGES_TYPES } from '../../../assets/appConstants';

function EnvSelector() {
    const currentEnv = window.globalConfigTools.currentEnvironment;

    const allEnvs = [
        {
            name: 'Wizecare USA',
            value: 'prod_usa',
            icon: <USFlagIcon />,
            showIn: ['local', 'localhost', 'dev', 'prod', 'prod_usa']
        },
        {
            name: 'Wizecare Global',
            value: 'prod',
            icon: <GlobalFlagIcon />,
            showIn: ['local', 'localhost', 'dev', 'prod', 'prod_usa']
        },
        {
            name: 'Local Environment',
            value: 'localhost',
            icon: <GlobalFlagIcon />,
            showIn: ['local', 'localhost']
        },
        {
            name: 'Development',
            value: 'dev',
            icon: <GlobalFlagIcon />,
            showIn: ['local', 'localhost', 'dev']
        }
    ];

    // Filter environments based on current environment
    const envs = allEnvs.filter(env => env.showIn.includes(currentEnv));

    // Find the current environment in the available environments
    const initialEnv = envs.find(env => env.value === currentEnv);
    const [selectedEnv, setSelectedEnv] = useState(initialEnv ? initialEnv.value : '');
    const [showOptions, setShowOptions] = useState(false);
    const selectorRef = useRef(null);

    const handleEnvChange = (env) => {
        setSelectedEnv(env.value);
        setShowOptions(false);
        
        // Send post message based on environment
        if (env.value === MESSAGES_TYPES.CLOUD_ENV_PROD) {
            postMessage(MESSAGES_TYPES.CLOUD_ENV_PROD);
        } else if (env.value === MESSAGES_TYPES.CLOUD_ENV_PROD_USA) {
            postMessage(MESSAGES_TYPES.CLOUD_ENV_PROD_USA);
        }
        changeRegion(env.value);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setShowOptions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div ref={selectorRef} className="env-selector" onClick={() => setShowOptions(!showOptions)}>
            <div className="env-flag">
                {selectedEnv ? 
                    envs.find(env => env.value === selectedEnv)?.icon || <GlobalFlagIcon /> 
                    : <GlobalFlagIcon />
                }
            </div>
            <div className={`selected-env-title ${showOptions ? 'expanded' : ''}`}>
                {selectedEnv ? envs.find(env => env.value === selectedEnv)?.name || selectedEnv : ''}
            </div>
            <div className={`arrow-icon ${showOptions ? 'open' : 'closed'}`}>
                <ArrowDownIcon />
            </div>
            {showOptions && (
                <div className={`env-options ${showOptions ? 'visible' : ''}`}>
                    {envs.filter(env => env.value !== selectedEnv).map(env => (
                        <div className="env-option" key={env.value} onClick={() => handleEnvChange(env)}>
                            <div className="env-icon">
                                {env.icon}
                            </div>
                            <div className="env-name">
                                {env.name}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default EnvSelector;
